import React, { useState, useEffect } from "react";
import Popup from "../design_components/Popup/Popup";
import { AnalyzeBlock } from "./styled";
import { Container, Heading, Text } from "../../styled";
import okIcon from "./../../resources/images/progressBar/ok_icon.svg";
import starIcon from "./../../resources/images/progressBar/star.svg";
import { blackColor } from "../../constants/colors";
import { useHistory } from "react-router";

const Analyze = ({ data, type }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [currentComment, setCurrentComment] = useState(0);
  const [percent, setPercent] = useState(0);
  const [stopPercent, setStopPercent] = useState(data.loaders[0].stopPercent);
  const [isPopupOpen, setPopupOpen] = useState(null);
  const [isSecondLoading, setSecondLoading] = useState(false);

  const history = useHistory();

  useEffect(() => {
    currentCommentIncrement(0);
  }, []);

  useEffect(() => {
    if (currentStep === data.loaders.length) {
      history.push(data.nextRoute);
      return;
    }
    setPercent(0);
    setTimeout(() => {
      setStopPercent(data.loaders[currentStep].stopPercent);
    }, 500);
  }, [currentStep]);

  useEffect(() => {
    if (!isSecondLoading) {
      setPercentIncrement(0);
    }
  }, [stopPercent]);

  useEffect(() => {
    if (isPopupOpen === true) {
      setSecondLoading(true);
      setStopPercent(100);
    }
    if (isPopupOpen === false) {
      setPercentIncrement(data.loaders[currentStep].stopPercent);
    }
  }, [isPopupOpen]);

  const currentCommentIncrement = (com) => {
    let currentComm = com;

    const next = () => {
      render();
    };

    const render = () => {
      setInterval(() => {
        currentComm = currentComm + 1;
        if (currentComm === data.comments.length) {
          currentComm = 0;
          setCurrentComment(currentComm);
        } else {
          setCurrentComment(currentComm);
        }
      }, 4000);
    };
    next();
  };

  const setPercentIncrement = (per) => {
    let currentPercent = per;

    const next = () => {
      render();
    };

    const render = () => {
      let int = setInterval(() => {
        currentPercent++;
        setPercent(currentPercent);
        if (currentPercent >= 100) {
          clearInterval(int);
          setCurrentStep(currentStep + 1);
          setSecondLoading(false);
        }
        if (currentPercent >= stopPercent && stopPercent !== 100) {
          clearInterval(int);
          setPopupOpen(true);
        }
      }, 50);
    };
    next();
  };

  const renderLoaderLines = () => {
    return data.loaders.map((loader, index) => {
      return (
        <AnalyzeBlock.Item key={`line-${index}`}>
          <AnalyzeBlock.Item.Top>
            <AnalyzeBlock.Item.Top.Left>
              <Text.Fourth>{loader.text}</Text.Fourth>
            </AnalyzeBlock.Item.Top.Left>
            <AnalyzeBlock.Item.Top.Right>
              {index === currentStep && (
                <Text.Fourth>{`${percent}%`}</Text.Fourth>
              )}
              {index < currentStep && (
                <AnalyzeBlock.Ok>
                  <img src={okIcon} alt="Done" />
                </AnalyzeBlock.Ok>
              )}
            </AnalyzeBlock.Item.Top.Right>
          </AnalyzeBlock.Item.Top>
          <AnalyzeBlock.Item.Bottom>
            <AnalyzeBlock.Item.Line style={{ background: loader.bgColor }}>
              {index === currentStep && (
                <AnalyzeBlock.Item.Loading
                  style={{ background: loader.color, width: `${percent}%` }}
                />
              )}
              {index < currentStep && (
                <AnalyzeBlock.Item.Loading
                  style={{ background: loader.color, width: `100%` }}
                />
              )}
            </AnalyzeBlock.Item.Line>
          </AnalyzeBlock.Item.Bottom>
        </AnalyzeBlock.Item>
      );
    });
  };

  const starsRender = (count) => {
    let starsArray = [];
    for (let i = 0; i < count; i++) {
      starsArray.push(
        <img
          style={{ marginRight: 3, marginLeft: 3 }}
          src={starIcon}
          alt="star"
        />
      );
    }
    return starsArray;
  };

  const renderComment = () => {
    return (
      <AnalyzeBlock.Comments.Item>
        <AnalyzeBlock.Comments.Item.Top>
          {starsRender(5)}
        </AnalyzeBlock.Comments.Item.Top>
        <AnalyzeBlock.Comments.Item.Text>
          <Text.Comment>{data.comments[currentComment].text}</Text.Comment>
        </AnalyzeBlock.Comments.Item.Text>
        <AnalyzeBlock.Comments.Item.Name>
          <Text.Comment.Name>
            {data.comments[currentComment].name}
          </Text.Comment.Name>
        </AnalyzeBlock.Comments.Item.Name>
      </AnalyzeBlock.Comments.Item>
    );
  };

  return (
    <AnalyzeBlock>
      <Container.Content>
        <AnalyzeBlock.Title>
          <Heading.Third>{data.title}</Heading.Third>
        </AnalyzeBlock.Title>
        <AnalyzeBlock.Items>{renderLoaderLines()}</AnalyzeBlock.Items>
        <Heading.Third style={{ color: blackColor, marginBottom: 30 }}>
          {data.subtitle}
        </Heading.Third>
        <AnalyzeBlock.Comments>{renderComment()}</AnalyzeBlock.Comments>
      </Container.Content>
      {isPopupOpen && (
        <Popup
          data={data.popups[currentStep]}
          cb={() => setPopupOpen(false)}
          eventFillName={data.popups[currentStep].eventFillName}
        />
      )}
    </AnalyzeBlock>
  );
};

export default Analyze;
